/**
 * @generated SignedSource<<ef32c2923490c21a37aadde26bcc9d12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DropdownMenus_UJPageMenu_user$data = {
  readonly customer: {
    readonly customerID: number;
  };
  readonly isAdmin: boolean;
  readonly permissions: {
    readonly allow: ReadonlyArray<string>;
    readonly deny: ReadonlyArray<string>;
  };
  readonly " $fragmentType": "DropdownMenus_UJPageMenu_user";
};
export type DropdownMenus_UJPageMenu_user$key = {
  readonly " $data"?: DropdownMenus_UJPageMenu_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"DropdownMenus_UJPageMenu_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DropdownMenus_UJPageMenu_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Permissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deny",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "15f452b277ac559845327c28799e5ab7";

export default node;
